import React from "react";

import {
  Content,
  Grid,
  GridItem,
  Label,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


const EducationDirectionProfession = ({
  profession = {}
}) => {
  const {
    title,
    paragraphs = []
  } = profession;

  if (!title && !paragraphs.length) {
    return null;
  }

  return (
    <PageSection
      id="profession"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-profession-title"
    >
      <Grid hasGutter>
        <GridItem
          span={12}
          md={4}
        >
          <Stack hasGutter>
            <StackItem>
              <Label
                color="blue"
                variant="outline"
              >
                Opis zawodu
              </Label>
            </StackItem>

            {title && (
              <StackItem>
                <Content>
                  <h2 id="education-direction-profession-title">
                    {title}
                  </h2>
                </Content>
              </StackItem>
            )}

            <StackItem>
              <Content>
                <p>
                  Poznaj charakter pracy oraz cechy
                  przydatne w tym zawodzie.
                </p>
              </Content>
            </StackItem>
          </Stack>
        </GridItem>

        <GridItem
          span={12}
          md={8}
        >
          <div
            style={{
              height: "100%",
              paddingInlineStart:
                "var(--pf-t--global--spacer--lg)",
              borderInlineStart:
                "2px solid var(--pf-t--global--color--brand--default)"
            }}
          >
            <Content>
              {paragraphs.map((paragraph, index) => (
                <p key={`${index}-${paragraph.slice(0, 20)}`}>
                  {paragraph}
                </p>
              ))}
            </Content>
          </div>
        </GridItem>
      </Grid>
    </PageSection>
  );
};


export default EducationDirectionProfession;